exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboardIFrame[data-v-3b76b699] {\n  width: 100%;\n  height: 100vh;\n}\n#powerbi-dashboard[data-v-3b76b699] {\n  height: 100%;\n}\n", ""]);

// exports
